<div>template route resolver</div>
